module.exports = __webpack_public_path__ + "img/pepars.a9eed18b.jpg";